import html2canvas from 'html2canvas';

// Debug comparison utility - to be temporarily added to SocialMediaManager for testing
export const createPreviewExportComparison = async (canvasId) => {
  console.log('🔍 Starting preview vs export comparison...');
  
  const canvasElement = document.getElementById(canvasId);
  if (!canvasElement) {
    console.error('Canvas not found');
    return;
  }

  // 1. Take a screenshot of current preview state
  const previewCanvas = await html2canvas(canvasElement, {
    width: 400,
    height: 400,
    scale: 1,
    logging: false,
    useCORS: true,
    allowTaint: true,
    backgroundColor: null
  });

  // 2. Take export screenshot with same settings as production export
  await new Promise(resolve => setTimeout(resolve, 500)); // Wait for fonts
  
  const exportCanvas = await html2canvas(canvasElement, {
    width: 400,
    height: 400,
    scale: 2,
    useCORS: true,
    allowTaint: true,
    backgroundColor: null,
    fontLoading: true,
    letterRendering: true,
    logging: false,
    onclone: (clonedDoc) => {
      // Just add font, no style overrides
      const existingFontLink = clonedDoc.querySelector('link[href*="fonts.googleapis.com"]');
      if (!existingFontLink) {
        const fontLink = clonedDoc.createElement('link');
        fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap';
        fontLink.rel = 'stylesheet';
        clonedDoc.head.appendChild(fontLink);
      }
    }
  });

  // 3. Save both images
  const previewURL = previewCanvas.toDataURL('image/png');
  const exportURL = exportCanvas.toDataURL('image/png');
  
  const previewLink = document.createElement('a');
  previewLink.download = `preview-${Date.now()}.png`;
  previewLink.href = previewURL;
  previewLink.click();
  
  setTimeout(() => {
    const exportLink = document.createElement('a');
    exportLink.download = `export-${Date.now()}.png`;
    exportLink.href = exportURL;
    exportLink.click();
  }, 1000);

  console.log('✅ Comparison images saved');
  return { previewURL, exportURL };
};
